// Validation utilities for forms

export const validateEmail = (email) => {
  if (!email) return { isValid: false, error: "Email is required" };
  
  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: "Please enter a valid email address" };
  }
  
  return { isValid: true, error: "" };
};

export const validatePassword = (password, minLength = 6) => {
  if (!password) return { isValid: false, error: "Password is required" };
  
  if (password.length < minLength) {
    return { isValid: false, error: `Password must be at least ${minLength} characters long` };
  }
  
  return { isValid: true, error: "" };
};

export const validateRequired = (value, fieldName) => {
  if (!value || value.toString().trim() === "") {
    return { isValid: false, error: `${fieldName} is required` };
  }
  
  return { isValid: true, error: "" };
};

export const validatePhone = (phone) => {
  if (!phone) return { isValid: false, error: "Phone number is required" };
  
  const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
  if (!phoneRegex.test(phone.replace(/\s+/g, ''))) {
    return { isValid: false, error: "Please enter a valid phone number" };
  }
  
  return { isValid: true, error: "" };
};

export const validateForm = (fields) => {
  const errors = {};
  let isValid = true;
  
  Object.keys(fields).forEach(fieldName => {
    const field = fields[fieldName];
    let validation = { isValid: true, error: "" };
    
    switch (field.type) {
      case 'email':
        validation = validateEmail(field.value);
        break;
      case 'password':
        validation = validatePassword(field.value, field.minLength);
        break;
      case 'phone':
        validation = validatePhone(field.value);
        break;
      case 'required':
        validation = validateRequired(field.value, field.label || fieldName);
        break;
      default:
        if (field.validator && typeof field.validator === 'function') {
          validation = field.validator(field.value);
        }
    }
    
    if (!validation.isValid) {
      errors[fieldName] = validation.error;
      isValid = false;
    }
  });
  
  return { isValid, errors };
};

export default {
  validateEmail,
  validatePassword,
  validateRequired,
  validatePhone,
  validateForm
};
